module.exports = ".card-header-right {\r\n    z-index: 999;\r\n}\r\n\r\n.card.full-card {\r\n  position: fixed;\r\n  top: 56px;\r\n  z-index: 99999;\r\n  -webkit-box-shadow: none;\r\n          box-shadow: none;\r\n  left: 0;\r\n  border-radius: 0;\r\n  border: 1px solid #ddd;\r\n  width: 100vw;\r\n  height: calc(100vh - 56px);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/directive/card/card.component.css
// module id = ./src/app/shared/directive/card/card.component.css
// module chunks = main